import styled from 'styled-components'

export const Container = styled.div`
  &[data-status='low'] {
    --color: var(--sl-fg-critical);
  }

  &[data-status='below_average'] {
    --color: var(--warning);
  }

  &[data-status='above_average'] {
    --color: var(--warning);
  }

  &[data-status='high'] {
    --color: var(--sl-fg-success);
  }

  font-size: 11px;

  /* PAC Tooltip underlines children; the chip is a control, not a help label */
  .Tooltip__Icon > div {
    text-decoration: none;
  }

  .label {
    color: var(--color);
  }

  .range {
    color: var(--sl-color-gray-6);
  }

  .suggestion {
    display: inline-flex;
    align-items: center;
    gap: var(--sl-space-1);
    white-space: nowrap;
    font-weight: 500;
    line-height: 14px;

    padding: var(--sl-space-1);
    border-radius: var(--sl-radius-1);
    background: color-mix(in srgb, var(--sl-color-purple-7) 10%, transparent);
    color: var(--sl-color-purple-7);

    .icon {
      color: inherit;
      width: max-content;
      display: inline-flex;

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
`

export const TooltipTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
`

export const SuggestionButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`
